import { use, createContext, useState, useMemo, useCallback } from 'react'
import { startOfWeek, endOfWeek } from 'date-fns'
import sortBy from 'lodash/sortBy'
import PropTypes from 'prop-types'
import useLocalStorage from '../../hooks/useLocalStorage/useLocalStorage'

export const NavigationContext = createContext({})
export const NavigationContextProvider = ({ children }) => {
  const [userBrands, setUserBrands] = useState([])
  const [selectedBrands, setSelectedBrands] = useLocalStorage(
    'SelectedBrands',
    [],
  )
  const [selectedOrg, setSelectedOrg] = useLocalStorage('SelectedOrg', {})
  const [selectedDateRange, setSelectedDateRange] = useState(() => {
    const now = new Date()
    return {
      label: 'This Week',
      range: {
        startDate: startOfWeek(now),
        endDate: endOfWeek(now),
      },
    }
  })

  const handleSetUserBrands = useCallback((brands) => {
    const isArray = Array.isArray(brands)
    setUserBrands(isArray ? sortBy(brands, ['name']) : [])
  }, [])

  const startDate = selectedDateRange?.range?.startDate?.getTime()
  const endDate = selectedDateRange?.range?.endDate?.getTime()
  const selectedBrandIds = useMemo(
    () => selectedBrands?.map((brand) => brand?.id),
    [selectedBrands],
  )
  const selectedOrgId = selectedOrg?.organization?.id

  if (!startDate || !endDate || startDate > endDate) {
    throw new Error('Date range is invalid')
  }

  const context = useMemo(
    () => ({
      setSelectedBrands,
      setSelectedDateRange,
      setSelectedOrg,
      selectedOrg,
      selectedOrgId,
      selectedBrands,
      selectedDateRange,
      userBrands,
      setUserBrands: handleSetUserBrands,
      startDate,
      endDate,
      selectedBrandIds,
    }),
    [
      setSelectedBrands,
      setSelectedOrg,
      selectedOrg,
      selectedOrgId,
      selectedBrands,
      selectedDateRange,
      userBrands,
      handleSetUserBrands,
      startDate,
      endDate,
      selectedBrandIds,
    ],
  )

  return <NavigationContext value={context}>{children}</NavigationContext>
}

export const useNavigationContext = () => use(NavigationContext)

NavigationContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf([PropTypes.node]),
  ]).isRequired,
}
